module.exports = __webpack_public_path__ + "img/benoit27.d2bd4019.jpg";